import { render, staticRenderFns } from "./TaxAddDialog.vue?vue&type=template&id=5815d1f6&scoped=true"
import script from "./TaxAddDialog.vue?vue&type=script&lang=js"
export * from "./TaxAddDialog.vue?vue&type=script&lang=js"
import style0 from "./TaxAddDialog.vue?vue&type=style&index=0&id=5815d1f6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5815d1f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5815d1f6')) {
      api.createRecord('5815d1f6', component.options)
    } else {
      api.reload('5815d1f6', component.options)
    }
    module.hot.accept("./TaxAddDialog.vue?vue&type=template&id=5815d1f6&scoped=true", function () {
      api.rerender('5815d1f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/TaxAddDialog.vue"
export default component.exports